export default __webpack_public_path__ + "88f1c758182d9770441381e94a6a5126.js";